module.exports = __webpack_public_path__ + "static/media/Collections-intimate-celebrations-Desktop.9e6bb1eb.webp";